var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Header', {
    attrs: {
      "showMemberCenter": false,
      "meta": _vm.meta,
      "page-title": _vm.getModuleConfig('page_title'),
      "page-image": _vm.getModuleConfig('page_image'),
      "page-kv-image": _vm.getModuleConfig('page_kv_image'),
      "header-section": _vm.getModuleConfig('header_section')
    }
  }), _vm._m(0)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wrapper"
  }, [_c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("活動方式")]), _c('div', {
    staticClass: "body"
  }, [_vm._v(" 使用者須先加入Coleman LINE宫方帳號，每成功邀請了位好友加入Coleman LINE官方帳號（受邀好友須末曾加入Coleman LINE宫方帳號)獲得一次抽獎機會（可重複參加）。 ")])]), _c('section', [_c('div', {
    staticClass: "title"
  }, [_vm._v("活動注意事項")]), _c('ul', [_c('li', [_vm._v(" 中獎名單將以Coleman LINE訊息推播通知。若主辦單位於7天内仍無法與中獎者取得聯繫或無法確認中獎資訊，則視為中獎者自動放棄中獎資格，且不再遞補中獎者。 ")]), _c('li', [_vm._v(" 獎項以實物為準，恕不挑尺寸及款式，中獎者亦不可要求更改漿項或兌換現金，主辦單位保留更換等值贈品的權利。活動贈品寄送範圍限台灣、金門、澎湖、馬祖。 ")]), _c('li', [_vm._v(" 兌獎時間及方式"), _c('br'), _vm._v(" (1) 兌講時間：2022/11/23~2022/12/2 23:59"), _c('br'), _vm._v(" a 實體獎品：2022/11/23~2022/12/2 23:59"), _c('br'), _vm._v(" b 非實體獎品：2022/11/23 18:00 統一匯入會員個人帳號 ")]), _c('li', [_vm._v(" 中獎名單將以Coleman LINE訊息推播通知。若主辦單位於7天内仍無法與中獎者取得聯繫或無法確認中獎資訊，則視為中獎者自動放棄中獎資格，且不再遞補中獎者。 ")])])])]);
}]

export { render, staticRenderFns }